export enum ResourceCategoryEnum {
  SEEDING = 'SEEDING',
  FERTILIZER = 'FERTILIZER',
  CHEMICAL_PESTICIDE = 'CHEMICAL_PESTICIDE',
  BIOLOGICAL_PESTICIDE = 'BIOLOGICAL_PESTICIDE',
  GRAFTING = 'GRAFTING',
  OTHER = 'OTHER',
}

export enum ResourceCostAccountEnum {
  TRAY = 'TRAY',
  SUBSTRATE = 'SUBSTRATE',
  VERMICULITE = 'VERMICULITE',
  PESTICIDE = 'PESTICIDE',
  FERTILIZER = 'FERTILIZER',
  GRAFTING_CLIP = 'GRAFTING_CLIP',
  GLOVE = 'GLOVE',
  BLADE = 'BLADE',
  STRETCH_PLASTIC = 'STRETCH_PLASTIC',
  OTHER = 'OTHER',
}

export const ResourceCategoryMapping = {
  [ResourceCategoryEnum.SEEDING]: {
    name: 'Semeio',
    url: 'Semeio',
  },
  [ResourceCategoryEnum.FERTILIZER]: {
    name: 'Fertilizantes',
    url: 'Fertilizantes',
  },
  [ResourceCategoryEnum.CHEMICAL_PESTICIDE]: {
    name: 'Defensivos químicos',
    url: 'DefensivosQuimicos',
  },
  [ResourceCategoryEnum.BIOLOGICAL_PESTICIDE]: {
    name: 'Defensivos biológicos',
    url: 'DefensivosBiologicos',
  },
  [ResourceCategoryEnum.GRAFTING]: {
    name: 'Enxertia',
    url: 'Enxertia',
  },
  [ResourceCategoryEnum.OTHER]: {
    name: 'Outros',
    url: 'Outros',
  },
};

export const ResourceCategoryUrlMapping = {
  [ResourceCategoryMapping[
    ResourceCategoryEnum.SEEDING].url
  ]: ResourceCategoryEnum.SEEDING,
  [ResourceCategoryMapping[
    ResourceCategoryEnum.FERTILIZER].url
  ]: ResourceCategoryEnum.FERTILIZER,
  [ResourceCategoryMapping[
    ResourceCategoryEnum.CHEMICAL_PESTICIDE].url
  ]: ResourceCategoryEnum.CHEMICAL_PESTICIDE,
  [ResourceCategoryMapping[
    ResourceCategoryEnum.BIOLOGICAL_PESTICIDE].url
  ]: ResourceCategoryEnum.BIOLOGICAL_PESTICIDE,
  [ResourceCategoryMapping[
    ResourceCategoryEnum.GRAFTING].url
  ]: ResourceCategoryEnum.GRAFTING,
  [ResourceCategoryMapping[
    ResourceCategoryEnum.OTHER].url
  ]: ResourceCategoryEnum.OTHER,
};

export const ResourceCostAccountMapping = {
  [ResourceCostAccountEnum.TRAY]: {
    name: 'Bandeja',
  },
  [ResourceCostAccountEnum.SUBSTRATE]: {
    name: 'Substrato',
  },
  [ResourceCostAccountEnum.VERMICULITE]: {
    name: 'Vermiculita',
  },
  [ResourceCostAccountEnum.PESTICIDE]: {
    name: 'Defensivo',
  },
  [ResourceCostAccountEnum.FERTILIZER]: {
    name: 'Fertilizante',
  },
  [ResourceCostAccountEnum.GRAFTING_CLIP]: {
    name: 'Clips',
  },
  [ResourceCostAccountEnum.GLOVE]: {
    name: 'Luva',
  },
  [ResourceCostAccountEnum.BLADE]: {
    name: 'Lâmina',
  },
  [ResourceCostAccountEnum.STRETCH_PLASTIC]: {
    name: 'Plástico Stretch',
  },
  [ResourceCostAccountEnum.OTHER]: {
    name: 'Outros',
  },
};
